import React from 'react';




function Inbox() {
    return <h1>"My Inbox"</h1>
}

export default Inbox;